<template>
  <div class="mobile-nav-buttons" ref="buttonContainer">
    <!-- {{this.$route}} -->
    <v-btn
      v-for="status in Statuses"
      :key="status.name"
      :class="{
        active: status?.id
          ? status?.id == this.$route.params.status
          : status.path == this.$route.path,
      }"
      @click="selectStatus(status.id)"
      rounded="pill"
      elevation="2"
      class="mr-2 font-weight-regular"
    >
      {{ status.name }} <span v-if="status.count"> | {{ status.count }}</span>
    </v-btn>
  </div>
</template>

<script>
// import { mapGetters } from 'vuex';

export default {
  name: "MobileNavButtons",
  props: {
    currentStatus: {
      type: String,
      default: "",
    },
    Statuses: {
      type: Array,
      required: true,
    },
    numberOfLines: {
      type: Number,
    },
  },
  //   computed: {
  //     ...mapGetters({
  //     //   Statuses: 'Finances/getFinancesStatuses',
  //     }),
  //   },
  methods: {
    selectStatus(status) {
      console.log(status);
      this.$router.push({ name: this.$route.name, params: { status: status } });
    },
  },
  mounted() {
    this.$nextTick(() => {
      if (this.$refs.buttonContainer) {
        this.$refs.buttonContainer.scrollLeft = 0;
      }
    });
  },
};
</script>

<style scoped lang="scss">
.mobile-nav-buttons {
  max-width: 100%;
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
  padding: 10px 0;

  &::-webkit-scrollbar {
    display: none;
  }

  .v-btn {
    flex: 0 0 auto;
    margin-right: 8px;
    background-color: #ffffff;
    box-shadow: unset !important;
    border: 1px solid #35bae033;
    color: $invoicesAndReturns;

    &.active {
      background-color: $invoicesAndReturns;
      color: white;
    }
  }
}
</style>